import { render, staticRenderFns } from "./onebox-login-mobile.vue?vue&type=template&id=202eb428&"
import script from "./onebox-login-mobile.vue?vue&type=script&lang=js&"
export * from "./onebox-login-mobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports